import React from 'react';
import { Flex, Loader } from '@marvelapp/ui';
export function LayerListLoader() {
    // TODO: make this a "content-aware" loading state,
    // e.g. create dummy "pulsating" layers
    return (React.createElement(Flex, { alignItems: "center", height: "100%", justifyContent: "center" },
        React.createElement(Loader, { size: 32 })));
}
